import { Directive, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from '@app/service/data.service';

@Directive({
  standalone: true,
  selector: '[ifInternalTeam]'
})
export class IfInternalTeamDirective implements OnDestroy {

  private readonly userSubscription: Subscription;
  private hasView = false;

  constructor(
    private readonly _templateRef: TemplateRef<unknown>,
    private readonly _viewContainerRef: ViewContainerRef,
    private readonly _dataService: DataService,
  ) {
    this.userSubscription = this._dataService.user$.subscribe(user => {
      const shouldRender = Boolean(user?.isTecincoMember);

      if (shouldRender && !this.hasView) {
        this._viewContainerRef.createEmbeddedView(this._templateRef);
        this.hasView = true;
        return;
      }

      if (!shouldRender && this.hasView) {
        this._viewContainerRef.clear();
        this.hasView = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }
}